export class AnalyticsData {
    Index: number;
    Value: any;

    constructor(index: number = 0, value: any = ''){
        this.Index = index;
        this.Value = value;
    }
}